import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from 'src/app/models/user.model';
import { Login, UserSession } from 'src/app/models/login.model';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { BaseService } from './base.service';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { ResetPasswordModel } from 'src/app/models/Auth.model';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';


@Injectable()
export class LoginService extends BaseService {

  private CurrentLogin: BehaviorSubject<Login>;

  gnBaseURL: any;

  constructor(private http: HttpClient,
    private appURL: AppConfigService,
    private router: Router) {
    super();
    let sessiondata = sessionStorage.getItem('currentUser');
    let loginObj: Login;
    if (sessiondata) {
      try {
        loginObj = JSON.parse(atob(sessiondata));
      } catch (e) {
        loginObj = new Login();
      }
    } else {

    }//this.router.navigate(['login']);
    this.CurrentLogin = new BehaviorSubject<Login>(loginObj);
  }
  get currentUser$(): Observable<Login> {
    return this.CurrentLogin.asObservable();
  }

  get currentUserValue(): Login {
    return this.CurrentLogin.value;
  }

  // Login
  login(UserName: string, Password: string) {
    this.gnBaseURL = this.appURL.getServerUrl();
    return this.http
      .post<any>(this.gnBaseURL + 'Auth', { UserName, Password })
      .pipe(
        map((user) => {
         this.setCurrentUser(user);
          return user;
        })
      );
      //.pipe(catchError(this.handleError));
  }
  // Set current login user details
  setCurrentUser(user: Login) {
    // store user details and jwt token in session storage to keep user logged in between page refreshes
    //sessionStorage.setItem('currentUser',JSON.stringify(user));
    sessionStorage.setItem('currentUser',btoa(JSON.stringify(user)));
    sessionStorage.setItem('currentUserEncrypt', btoa(JSON.stringify(user)));
    this.CurrentLogin.next(user);
  }

  clearSession() {
    // remove user from session storage to log user out
    sessionStorage.clear();
    this.CurrentLogin.next(new Login());
  }

  forgotPassword(username: string) {
    this.gnBaseURL = this.appURL.getServerUrl();
    return this.http
      .post<any>(this.gnBaseURL + 'Auth/forgotpassword', { UserName: username })
      .pipe(catchError(this.handleError));
  }

  // Reset Password
  //check all conditions to check impact of redirecting to login page on reset password
  resetPassword(model: ResetPasswordModel) {
    this.gnBaseURL = this.appURL.getServerUrl();
    console.log(model);
    return this.http
      .post<any>(this.gnBaseURL + 'Auth/resetpassword', model);
      //.pipe(catchError(this.handleError));
  }

  userSesionReg(model: UserSession): Observable<UserSession> {
    this.gnBaseURL = this.appURL.getServerUrl();
    return this.http.post<UserSession>(
      this.gnBaseURL + 'UserSession/AddUserSession',
      model
    );
  }

}
